import { render, staticRenderFns } from "./CPFundSummary.vue?vue&type=template&id=4c1cd391&scoped=true&"
import script from "./CPFundSummary.vue?vue&type=script&lang=ts&"
export * from "./CPFundSummary.vue?vue&type=script&lang=ts&"
import style0 from "./CPFundSummary.vue?vue&type=style&index=0&id=4c1cd391&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1cd391",
  null
  
)

export default component.exports